import React from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "lucide-react";
import { Calendar as CalendarComponent } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";
import { formatInDeviceTimezone } from "@/utils/dateUtils";

interface DateFieldProps {
  label: string;
  date: Date;
  onDateChange: (date: Date) => void;
  placeholder?: string;
}

const DateField: React.FC<DateFieldProps> = ({
  label,
  date,
  onDateChange,
  placeholder = "gg/aa/yyyy"
}) => {
  return (
    <div className="space-y-1.5">
      <label htmlFor="date" className="block text-[11px] font-semibold uppercase tracking-[0.04em] text-gray-600">
        {label}
      </label>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "w-full justify-start text-left font-mono text-[13px] border-gray-200 bg-white hover:bg-gray-50 rounded-md h-10",
              !date && "text-gray-400",
            )}
          >
            <Calendar className="mr-2 h-4 w-4 text-gray-400 font-sans" />
            {date ? formatInDeviceTimezone(date, "dd.MM.yyyy") : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <CalendarComponent
            mode="single"
            selected={date}
            onSelect={(date) => date && onDateChange(date)}
            initialFocus
            className="p-3 pointer-events-auto"
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DateField;
